import { Component, Inject, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { ConfigService } from '../../../config.service';
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { GlobalDataService } from '../../../services/global-data.service';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import {AuthService} from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-call-pricing-list',
  templateUrl: './calls-pricing-list.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class BOPricingListComponent implements OnInit {
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  attributes: CognitoUserAttribute[] = [];
  canAccess = false;

  itemsList: any[] = [];
  paginationToken: string | null = null;
  hasMoreItems: boolean = true;
  loading: boolean = false;
  filteredCounts: { itemsList: number } = { itemsList: 0 };
  filterItems: any[] = [];

  constructor(
    private router: Router,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  // Cargar usuarios al inicializar el componente
  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    this.loading = true;
    await this.auth.refresh()
    this.user = await Auth.currentAuthenticatedUser();

    this.filterItems = [
      { key: 'network', type: 'text', label: 'Network'  },
      { key: 'toCountryCode', type: 'text', label: 'Country code' },
      { key: 'amountPerMinuteEuro', type: 'text', label: 'Amount' },
      { key: 'createdAt', type: 'date-range', label: 'Created at' },
      { key: 'updatedAt', type: 'date-range', label: 'Updated at' },
    ];

    this.itemsList = await this.getItems();
    this.itemsList.sort((a, b) => a.id.localeCompare(b.id));

    this.loading = false;
  }

  async getItems(): Promise<any> {
    return await this.lambda.getLambdaFunction('lambda', '/pricing/calls', {
      queryStringParameters: { method: 'full' }
    });
  }

  async loadMore(): Promise<void> {
    console.log('> load more');
  }

  onNewItem(): void {
    console.log('> onNewItem');
    // this.router.navigate(['/backoffice/calls-pricing/edit']);
  }

  onItemClick(item: any): void {
    sessionStorage.setItem('boCallPriceEdit', item.id);
    this.router.navigate(['/backoffice/calls-pricing/edit']);
  }
}
